import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/training-programs/$slug")({
  staticData: { title: "Training Program" },
  component: () => <Outlet />,
});
